<template>
  <div class="create-bom s bom-main">
    <div class="material"  ref="left" :style="{ 'max-width': showProductCode ? '55%' : 'none' }">
      <div class="material-bar" ref="materialBar">
        <div class="material-bar--title">{{ replaceMode ?"Replace ":"Add " }} Material</div>
        <div class="input-group search">
          <input type="text" v-model="searchKeyWord" @input="updateOnSearch" placeholder=" Filter by Name, ID, Product Code, and Description" />
        </div>
      </div>
      <div ref="materialFilters">
      <filterTag :tags="getTags" @new-tag="addNewTag" :type="1"
      @update-tags="updateTags" title="Add tags to filter"
      />
      </div>
      <div
        class="material-table dtx-table"
        ref="materialTable"
        :style="{ height: materialTableHeight ? `${materialTableHeight}px` : null }"
      >
        <table style="min-width: 800px">
          <thead>
            <tr>
              <th></th>
              <th>Product Code</th>
              <th>Material ID</th>
              <th>PLM ID</th>
              <th>ERP ID</th>
              <th>UOM</th>
              <th>Description</th>
              <th>Lead Time</th>
              <th>Action </th>
            </tr>
          </thead>
          <tbody v-if="!materialMasterLoading">
            <tr v-for="item in materialMasterData" :key="item.material_id" :class="{'materialReplaceMode': replaceMaterialMode && replaceRowIndex !== -1 && !isSelfProductMaterial(item), 'material-row-cyclic': replaceMode && isSelfProductMaterial(item)}"   @click="handleReplaceClick(item)"
 >

              <td v-if="item.product_code!== productCode && !replaceMode" @click="addToBom(item)">
                <img
                  v-if="addedBomItems.includes(item.id)"
                  src="~@/assets/images/icons/checked-icon.svg"
                  alt=""
                />
                <img
                  v-else
                  src="~@/assets/images/icons/unchecked-icon.svg"
                  alt=""
                />
              </td>
              <td v-else></td>
              <td v-overflow-tooltip>{{ item.product_code_name ||  item.material_product_code?.product_code || "--" }}</td>
              <td v-overflow-tooltip>{{ item.custom_material_id || "--" }}</td>
              <td v-overflow-tooltip>{{ item.plm_material_id || "--" }}</td>
              <td v-overflow-tooltip>{{ item.erp_material_id || "--" }}</td>
              <td v-overflow-tooltip>{{ item.material_unit_details?.name || "--" }}</td>
              <td v-overflow-tooltip>{{ item.material_description || "--" }}</td>
              <td>{{ item.lead_time || "--" }}</td>
              <td class="pointer" @click.stop>
              <img @click="openDetailModal(item.id)" class="mx-2" width="16" src="~@/assets/images/eye.svg" alt="view" />
              </td>
            </tr>
          </tbody>
        </table>
        <div class="center p-6">
          <loading-circle v-if="materialMasterLoading" />
        </div>
      </div>
      <div class="pagination-footer" ref="materialPaginationFooter">
      <pagination
        :length="totalCount"
        :perPage="perPage"
        :pageNumber="pageNumber"
        @selectPage="selectPage"
      />
      <span class="pagination-footer-total mt-4">Total Materials :  &nbsp;  <b> {{ totalCount }}</b></span>
    </div>
      <modal
      @close="closeDetailModal"
      :open="detailModalObject.isOpen"
      title="Material Detail View"
      :closeOnOutsideClick="true"
    >
      <detail-material-master
        v-if="detailModalObject.selectedId !== -1"
        :materialMaster="detailModalObject.detailMaterialData"
        :loading="detailModalObject.loading"
      />
      </modal>
    </div>
    <div class="resizer" ref="resizer" @mousedown="startResize"></div>
    <div class="bom-detail" :style="{ 'width': showProductCode ? '0' : 'auto', 'flex-grow': showProductCode ? '1' : 'unset' }">
      <div class="bom-detail-bar">
        <div class="bom-detail-bar--title flex" ><div class="bom-detail-bar--title-update">Update BOM  &nbsp;</div> <div v-overflow-tooltip class="elipsis-text flex-grow "> ({{bomName}})</div></div>
      </div>
      <div  class="input-group mt-2" :class="{'addBomForm': moreInput}">
      <div class="input-group mt-2">
        <label>Product Code</label>
        <input type="text" disabled v-model="productName" />
      </div>
      <div class="input-group mt-2">
        <label>Bom Name</label>
        <input  type="text" v-model="bomName" />
      </div>
      <div class="input-group mt-2">
        <label>ERP BOM Id</label>
        <input type="text" disabled v-model="erpBomId" />
      </div>
      <div class="input-group mt-2">
        <label>Copy From</label>
        <select v-model="selectedBomVersion" @change="manageVersionChange">
          <option v-for="version in this.bomVersions" :key="version.id" :value="version.id"> V - {{version.version_no}}</option>
        </select>
      </div>
      <effective-date :date="selectedDate" @date-selected="selectedDate=$event" />
      <div class="input-group mt-3  underline pointer" v-if="!moreInput">
        <label @click="toggleMore">Add Standard Bom Form</label>
      </div>
      <div class="mt-3" v-show="moreInput">
        <std-Bom-Form ref="stdBomForm" @stdBomForm="handleBomForm" :stdFormValues="standardBomForm" :stdBomVersionId="stdBomVersionId" @validationErrors="handleValidationErrors" />
      </div>
    </div>
    <div class="input-group mt-3 underline pointer" v-if="moreInput">
        <label @click="toggleMore">Show Less</label>
      </div>
      <div class="bom-detail-item dtx-table mt-3">
        <div class="bom-detail-item--no-material" v-if="!bom_items.length">
          Add at least One Material
        </div>
        <table v-else>
          <thead>
            <tr>
              <th>Material ID</th>
              <th class="elipsis-text" style="width: 100px">Description</th>
              <th>Quantity</th>
              <!-- <th>Total Price</th> -->
              <th>Unit Size</th>
              <th>Type</th>
              <th>Material Cost</th>
              <th>Material Price</th>
              <th>Bom</th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in bom_items"
              :key="index"
              :class="{'selectedMaterial': index===replaceRowIndex, 'bom-item-row-disabled': isObsoleteMaterial(item) }"
            >
                <td class="pointer" @click="replaceRowIndex=replaceMode?index:null">{{ item.custom_material_id || "--" }}</td>
                <td class="pointer" @click="replaceRowIndex=replaceMode?index:null">
                <div
                  v-overflow-tooltip
                  class="elipsis-text"
                  style="width: 120px"
                >
                  {{ item.material_description || "--" }}
                </div>
              </td>
              <td>
                <input
                  type="number"
                  v-model.number="bom_items[index].quantity"
                  @change="validateQuantity(index)"
                  min="1"
                  @keydown="changeNumber"
                  :disabled="isObsoleteMaterial(item)"
                />
              </td>
              <!-- <td>
                <input
                  disabled
                  type="number"
                  v-model.number="bom_items[index].total_price"
                  @keyup="updateTagState(index)"
                  @change="updateTagState(index)"
                />
              </td> -->
              <td>
                <input
                  type="number"
                  v-model.number="bom_items[index].unit_size"
                  @change="validateUnitSize(index)"
                  min="1"
                  @keydown="changeNumber"
                  :disabled="isObsoleteMaterial(item)"
                />
              </td>
              <td>
              <select class="custom-list-select" @change="bom_items[index].overridden_fields.material_group = true" v-model="bom_items[index].material_group" name="" id="" :disabled="isObsoleteMaterial(item)">
                <option v-for="options in filteredCustomList(index)" :key="options.id" :value="options.id">
                {{ options.name }}</option>
              </select>
              </td>
              <td><input
                class="resized-box"
                @change="bom_items[index].overridden_fields.unit_cost = true"
                v-model.number="bom_items[index].material_unit_cost"
                min="0"
                  type="number"
                  @keydown="changeNumber"
                  :disabled="isObsoleteMaterial(item)"
                /></td>
              <td><input
                class="resized-box"
                @change="bom_items[index].overridden_fields.sale_price = true"
                v-model.number="bom_items[index].material_unit_sale_price"
                min="0"
                  type="number"
                  @keydown="changeNumber"
                  :disabled="isObsoleteMaterial(item)"
                /></td>
              <td>
                <div v-if="!item.associated_bom_id">
                  <img
                    v-if="item.product_code"
                    :class="{
                      'add-bom': true,
                      active: true,
                      'ml-2': true,
                    }"
                    v-tooltip="'Associate Bom'"
                    src="~@/assets/images/icons/add-new-icon.svg"
                    width="20px"
                    alt=""
                    @click="openAssociateBomModal(item, index)"
                  />
                  <img
                    v-else
                    :class="{
                      'add-bom': true,
                      active: false,
                      'ml-2': true,
                    }"
                    src="~@/assets/images/icons/add-new-icon.svg"
                    width="20px"
                    alt=""
                  />
                </div>
                <div
                  v-else
                  class="associated-bom"
                  v-tooltip="item.associated_bom_name"
                  @click="openAssociateBomModal(item, index)"
                >
                  {{ item.associated_bom_name }}
                </div>
              </td>
              <td>
                <div class="action" @click.stop="openDrawer(item, index)">
                  <img v-tooltip="'Add custom fields'"  class="pointer mx-1" src="~@/assets/images/icons/forms-doc.svg" alt=""  width="12"/>
                </div>
              </td>
              <td>
                <div @click="openRemarkModal(index)" v-tooltip="`${item.remarks ?? 'Remarks'}`">
                  <img class="pointer" src="~@/assets/images/icons/add-remarks-icon.svg" width="16px" alt="" />
                </div>
              </td>
              <td class="action-cell">
                <div class="action" @click="removeBomItem(item, index)">
                  <img class="pointer" src="~@/assets/images/close.png" width="16px" alt="" />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="v-center my-4 flex-end bom-action-footer">
        <div class="addorreplace-btnbox">
          <div ref="addOrReplace" class="addorreplace-selectedbg"></div>
          <div class="addorreplace-addbtn" @click="enabaleAddMode"  title="Cumulative Data" >Add</div>
          <div class="addorreplace-replacebtn" @click="enableReplaceMode" title="Individual user">Replace</div>
        </div>
        <button class="btn btn-cancel ml-2" @click="cancelEdit">
          Cancel
        </button>
        <button class="btn ml-2" :disabled="bom_items.length == 0" @click="save">Save</button>
      </div>
    </div>
    <div v-if="drawer" class="drawer" :class="drawer ? 'open' : 'close'" v-click-outside="closeDrawer">
        <create-material-form  @cancel="closeDrawer" @create-material="handleCreateMaterial"  :createMaterialValues="standardMaterialData.newMaterialData"> </create-material-form>

    </div>
    <modal
      title="Add remarks"
      :open="addRemarkModalObject.isOpen"
      @close="addRemarkModalObject.isOpen = false"
    >
    <div class="p-4">
      <div class="input-group mt-2">
          <label>Remarks</label>
          <textarea class="remarks" v-model="addRemarkModalObject.remarks">
          </textarea>
        </div>
        <div class="v-center my-4 flex-end">
          <button class="btn btn-cancel ml-2" @click="addRemarkModalObject.isOpen = false">
            Cancel
          </button>
          <button class="btn ml-2" @click="saveRemarks">Save</button>
        </div>
    </div>
    </modal>
    <modal
      :open="associateBom.show"
      @close="closeAssociateBomModal"
      title="Associate Bom"
    >
      <select-bom
        v-if="associateBom.show"
        :product_code="associateBom.product_code"
        :selectedBomId="associateBom.associated_bom_id"
        :selectedBomVersionId="associateBom.associated_bom_version_id"
        :parentProdCode="productCode"
        :projectId="null"
        @selectBom="selectAssociateBom"
        @close="closeAssociateBomModal"
        :showCloseButton="true"
      />
    </modal>
  </div>
</template>

<script>
import {
  MaterialGroup,
  GetMaterialMasterForBom,
  GetProductCode,
  GetBomDetailById,
  GetAllBomItemsByBomVersionId,
  GetSingleMaterialMasterData,
  updateEffectedDate,
  updateBomName,
  GetAllBomVersionListByBomId,
  ResourceGroup,
  deleteAllBomItems,
  deleteAllBomItemsAndInsert,
  updateStdBomVersions,
  GetFormDataByFormId
} from '@/api'
import loadingCircle from '../../../components/common/loadingCircle.vue'
import Pagination from '../../../components/common/pagination.vue'
import filterTag from '../../../components/common/filterTag.vue'
import { debounce } from '@/utils/debounce'
import { alert, warning, success } from '@/plugins/notification'
import Modal from '../../../components/common/modal.vue'
import SelectBom from '../../../components/bom/common/selectBom.vue'
import { mapGetters, mapMutations } from 'vuex'
import DetailMaterialMaster from '../../../components/materialMaster/detailMaterialMaster.vue'
import Loader from '@/plugins/loader'
import effectiveDate from '../../../components/common/effectiveDate.vue'
import createMaterialForm from '../bomForm/createMaterialForm.vue'
import stdBomForm from '../bomForm/stdBomForm.vue'
import { restrictKeys } from '@/utils/validations'
import resizeHelper from '@/helper/Bom/resizeHelper'
import { formDataRetriver } from '../bomHelper'
import Config from '@/config'

export default {
  components: { loadingCircle, Pagination, Modal, SelectBom, DetailMaterialMaster, filterTag, effectiveDate, createMaterialForm, stdBomForm },
  name: 'EditProductBom',
  data () {
    return {
      selectedBomVersion: '',
      copyVersionChanged: false,
      bomVersions: [],
      customList: [],
      currentBomItems: [],
      materialMasterData: [],
      materialMasterLoading: false,
      pageNumber: 1,
      windowHeight: window.innerHeight,
      calculatedPerPage: Math.max(1, Math.floor((window.innerHeight - 210) / 28)),
      materialTableHeight: null,
      measuredMaterialHeaderHeight: 42,
      measuredMaterialRowHeight: 33,
      materialTableResizeObserver: null,
      materialTableMeasureFrame: null,
      materialMasterRequestId: 0,
      totalCount: 0,
      searchKeyWord: '',
      updateOnSearch: null,
      bomName: '',
      tempBomName: '',
      erpBomId: '',
      bomId: null,
      productName: '',
      productCode: '',
      bom_items: [],
      associateBom: {
        show: false,
        product_code: null,
        associated_bom_id: null,
        associated_bom_name: null,
        associated_bom_version: null,
        associated_bom_version_id: null,
        item: null,
        index: null
      },
      detailModalObject: {
        isOpen: false,
        selectedId: -1,
        detailMaterialData: {}
      },
      selectedDate: '',
      selectedDateTemp: '',
      previousUnitSize: [],
      addRemarkModalObject: {
        isOpen: false,
        selectedIndex: -1,
        remarks: ''
      },
      replaceRowIndex: -1,
      replaceMode: false,
      drawer: false,
      moreInput: false,
      standardMaterialData: {
        newMaterialData: null,
        index: null
      },
      standardBomForm: null,
      validationError: [],
      stdBomTempId: null,
      stdBomVersionId: null,
      // these states are for resizing
      startX: 0,
      startWidth: 0,
      boundMove: null,
      boundUp: null
    }
  },
  computed: {
    ...mapGetters('productBom', ['selectedBomId']),
    ...mapGetters('tag', ['getTags']),
    showProductCode () {
      return ((this.$route.path.includes('/bom') && this.$route.path.includes('/edit')) || (this.$route.path.includes('/bom') && this.$route.path.includes('/new')))
    },
    addedBomItems () {
      return this.bom_items.map((item) => {
        return item.material_id
      })
    },
    replaceMaterialMode () {
      if (this.replaceRowIndex === -1 || !this.replaceMode) {
        return false
      } else return true
    },
    perPage () {
      return this.calculatedPerPage
    }

  },
  watch: {
    '$store.state.tag.tags': function () {
      this.pageNumber = 1
      this.scheduleMaterialTableMeasure({ fetch: true, resetPage: true })
    }
  },
  methods: {
    getOuterHeight (element) {
      if (!element) return 0
      const rect = element.getBoundingClientRect()
      const style = window.getComputedStyle(element)
      const marginTop = parseFloat(style.marginTop) || 0
      const marginBottom = parseFloat(style.marginBottom) || 0
      return rect.height + marginTop + marginBottom
    },
    scheduleMaterialTableMeasure (options = {}) {
      if (this.materialTableMeasureFrame) {
        window.cancelAnimationFrame(this.materialTableMeasureFrame)
      }
      this.$nextTick(() => {
        this.materialTableMeasureFrame = window.requestAnimationFrame(() => {
          this.materialTableMeasureFrame = null
          this.updateMaterialPageSize(options)
        })
      })
    },
    setupMaterialTableResizeObserver () {
      if (typeof ResizeObserver === 'undefined') return
      this.materialTableResizeObserver = new ResizeObserver(() => {
        this.scheduleMaterialTableMeasure({ fetchOnChange: true })
      })
      const observedElements = [
        this.$refs.left,
        this.$refs.materialBar,
        this.$refs.materialFilters,
        this.$refs.materialPaginationFooter
      ]
      observedElements.forEach((element) => {
        if (element) this.materialTableResizeObserver.observe(element)
      })
    },
    getMeasuredMaterialTableSize () {
      const materialPanel = this.$refs.left
      const tableWrapper = this.$refs.materialTable
      if (!materialPanel || !tableWrapper) return null

      const panelRect = materialPanel.getBoundingClientRect()
      const panelStyle = window.getComputedStyle(materialPanel)
      const panelBottomPadding = parseFloat(panelStyle.paddingBottom) || 0
      const panelBottom = Math.min(panelRect.bottom - panelBottomPadding, window.innerHeight)
      const tableTop = tableWrapper.getBoundingClientRect().top
      const footerHeight = this.getOuterHeight(this.$refs.materialPaginationFooter)
      const tableStyle = window.getComputedStyle(tableWrapper)
      const tableVerticalMargins = (parseFloat(tableStyle.marginTop) || 0) + (parseFloat(tableStyle.marginBottom) || 0)
      const availableHeight = Math.floor(panelBottom - tableTop - footerHeight - tableVerticalMargins)

      const header = tableWrapper.querySelector('thead')
      const rows = Array.from(tableWrapper.querySelectorAll('tbody tr'))
      const headerHeight = header?.getBoundingClientRect().height || this.measuredMaterialHeaderHeight
      const rowHeight = rows.length
        ? Math.max(...rows.map(row => row.getBoundingClientRect().height))
        : this.measuredMaterialRowHeight
      const horizontalScrollbarHeight = tableWrapper.scrollWidth > tableWrapper.clientWidth
        ? tableWrapper.offsetHeight - tableWrapper.clientHeight
        : 0

      if (headerHeight > 0) this.measuredMaterialHeaderHeight = headerHeight
      if (rowHeight > 0) this.measuredMaterialRowHeight = rowHeight

      return {
        availableHeight,
        headerHeight: this.measuredMaterialHeaderHeight,
        rowHeight: this.measuredMaterialRowHeight,
        horizontalScrollbarHeight: Math.max(0, horizontalScrollbarHeight),
        tableHeight: tableWrapper.querySelector('table')?.getBoundingClientRect().height || 0
      }
    },
    updateMaterialPageSize ({ fetch = false, fetchOnChange = false, resetPage = false } = {}) {
      const measured = this.getMeasuredMaterialTableSize()
      const headerHeight = measured?.headerHeight || this.measuredMaterialHeaderHeight
      const rowHeight = measured?.rowHeight || this.measuredMaterialRowHeight
      const horizontalScrollbarHeight = measured?.horizontalScrollbarHeight || 0
      const availableHeight = measured?.availableHeight || (this.windowHeight - 210)
      const rowsHeight = Math.max(0, availableHeight - headerHeight - horizontalScrollbarHeight - 2)
      const nextPerPage = Math.max(1, Math.floor(rowsHeight / rowHeight))
      const rowsForHeight = this.materialMasterLoading
        ? nextPerPage
        : Math.min(nextPerPage, Math.max(this.materialMasterData.length, 1))
      const nextTableHeight = Math.max(
        Math.min(availableHeight, Math.ceil(headerHeight + rowsForHeight * rowHeight + horizontalScrollbarHeight + 2)),
        Math.ceil(headerHeight + rowHeight + horizontalScrollbarHeight + 2)
      )
      const perPageChanged = nextPerPage !== this.calculatedPerPage

      this.materialTableHeight = nextTableHeight

      if (!perPageChanged) {
        if (fetch) this.fetchMaterialMasterData()
        return
      }

      const lastPage = Math.max(1, Math.ceil(this.totalCount / nextPerPage))
      this.calculatedPerPage = nextPerPage
      this.pageNumber = resetPage ? 1 : Math.min(this.pageNumber, lastPage)

      if (fetch || fetchOnChange) {
        this.fetchMaterialMasterData()
      }
    },
    settleMaterialTableOverflow () {
      const measured = this.getMeasuredMaterialTableSize()
      if (!measured) return

      const contentHeight = Math.ceil(measured.tableHeight + measured.horizontalScrollbarHeight + 2)
      if (contentHeight <= measured.availableHeight) {
        this.materialTableHeight = Math.max(contentHeight, Math.ceil(measured.headerHeight + measured.rowHeight + measured.horizontalScrollbarHeight + 2))
        return
      }

      if (this.calculatedPerPage <= 1) {
        this.materialTableHeight = measured.availableHeight
        return
      }

      const overflowRows = Math.max(1, Math.ceil((contentHeight - measured.availableHeight) / measured.rowHeight))
      const nextPerPage = Math.max(1, this.calculatedPerPage - overflowRows)
      if (nextPerPage === this.calculatedPerPage) return

      const lastPage = Math.max(1, Math.ceil(this.totalCount / nextPerPage))
      this.calculatedPerPage = nextPerPage
      this.pageNumber = Math.min(this.pageNumber, lastPage)
      this.fetchMaterialMasterData()
    },
    changeNumber (event) {
      if (['e', 'E', '+', '-'].includes(event.key)) {
        restrictKeys(event)
      }
    },
    handleValidationErrors (errors) {
      this.validationError = errors // Store the errors to display
    },
    toggleMore () {
      this.moreInput = !this.moreInput
    },
    openDrawer (item, index) {
      this.standardMaterialData.newMaterialData = item
      this.standardMaterialData.index = index
      this.drawer = !this.drawer
    },
    closeDrawer () {
      this.drawer = false
    },
    handleCreateMaterial (obj) {
      this.bom_items[this.standardMaterialData.index].overridden_material_fields =
      obj || null
      this.closeDrawer()
    },
    handleBomForm (data) {
      this.standardBomForm = data || null
    },
    filteredCustomList (index) {
      const materialType = this.bom_items[index].type
      return this.customList.filter(option => option.type === materialType)
    },
    isObsoleteMaterial (item) {
      return item?.material_status === Config.MATERIAL_STATUS_INVERTED_MAP.OBSELETE
    },
    isSelfProductMaterial (item) {
      return !!this.productCode && item?.product_code === this.productCode
    },
    manageVersionChange () {
      this.bom_items = []
      this.copyVersionChanged = true
      GetAllBomItemsByBomVersionId(this.selectedBomVersion).then((res) => {
        const bomItems = res.bom_items.map((item) => {
          // if overrided value is not there pick the cost from assoc bom version or the material
          const unitCost = item.material_unit_cost ?? (item.associated_product_code_bom ? item.associated_bom_version?.total_cost : item.core_material.unit_cost)
          const salePrice = item.material_unit_sale_price ?? (item.associated_product_code_bom ? item.associated_bom_version?.sale_price : item.core_material.unit_sale_price)

          return {
            material_id: item.material_id,
            custom_material_id: item.core_material.custom_material_id,
            quantity: item.quantity,
            total_price: item.total_price,
            unit_size: +item.unit_size,
            remarks: item.remarks,
            material_unit_cost: unitCost,
            material_unit_sale_price: salePrice,
            material_group: item.material_group,
            material_description: item.core_material.material_description,
            product_code: item.core_material.product_code,
            associated_bom_id:
              item?.associated_bom_version?.core_bom?.id || null,
            associated_bom_name:
              item?.associated_bom_version?.core_bom?.name || null,
            associated_bom_version:
              item?.associated_bom_version?.version_no || null,
            associated_bom_version_id: item?.associated_bom_version?.id || null,
            type: item.core_material.type,
            material_status: item.core_material.status,
            overridden_fields: {
              unit_cost: !!item.material_unit_cost,
              sale_price: !!item.material_unit_sale_price,
              material_group: !!item.material_group,
              resource_group: !!item.resource_group
            },
            plugin_metadata: item.plugin_metadata
          }
        }) || []
        this.bom_items = JSON.parse(JSON.stringify(bomItems))
        this.previousUnitSize = JSON.parse(JSON.stringify(this.bom_items))
      }).catch(() => {
        alert('Something went wrong')
      })
    },
    openDetailModal (id) {
      const loader = new Loader()
      loader.show()
      GetSingleMaterialMasterData({ id }).then(res => {
        loader.hide()
        this.detailModalObject.isOpen = true
        this.detailModalObject.selectedId = id
        this.detailModalObject.detailMaterialData = res.core_material_master[0]
      }).finally(() => {
        loader.hide()
      })
    },
    closeDetailModal () {
      this.detailModalObject.isOpen = false
      this.detailModalObject.selectedId = -1
    },
    validateMaterialUnitCost () {
      const bomItemMap = new Map()
      for (const item of this.bom_items) {
        const key = item.material_id.concat('_', item.unit_size)
        if (bomItemMap.has(key)) {
          return false
        }
        bomItemMap.set(key, item.unit_size)
      }
      return true
    },
    async save () {
      const hasObsoleteMaterial = this.bom_items.some(item => item?.material_status === Config.MATERIAL_STATUS_INVERTED_MAP.OBSELETE)
      if (hasObsoleteMaterial) {
        alert('BOM cannot be saved until obsolete materials are cleared.')
        return
      }
      if (this.bom_items.some(item => this.isSelfProductMaterial(item))) {
        alert('Cyclic dependency is not allowed: remove the material with the same product code as this BOM before saving.')
        return
      }

      const checkResult = this.validateMaterialUnitCost()
      if (this.bom_items.some(item => item.material_unit_cost < 0 || item.material_unit_sale_price < 0)) {
        alert('negative number not allowed')
        return
      }
      if (!checkResult) {
        alert('Unit Size should not be same for same material')
        return
      }
      if (!this.bomName) {
        alert('BOM Name is required')
        return
      }
      const errors = await this.$refs.stdBomForm.validateInputData()
      if (errors === null) return
      if (errors?.length) {
        errors.forEach(e => alert(e))
        return
      }
      const loader = new Loader()
      try {
        const checkResult = this.validateMaterialUnitCost()
        if (this.bom_items.some(item => item.material_unit_cost < 0 || item.material_unit_sale_price < 0)) {
          alert('negative number not allowed')
          return
        }
        if (!checkResult) {
          alert('Unit Size should not be same for same material')
          return
        }
        loader.show()
        if (!this.copyVersionChanged) {
          const newItems = this.bom_items.map((item) => {
            return {
              associated_product_code_bom: item.associated_bom_version_id,
              bom_version_id: this.bomVersionId,
              bom_id: this.selectedBomId,
              material_id: item.material_id,
              quantity: item.quantity,
              total_price: item.total_price,
              unit_size: item.unit_size,
              remarks: item.remarks,
              material_unit_cost: item.overridden_fields.unit_cost ? item.material_unit_cost : null,
              material_unit_sale_price: item.overridden_fields.sale_price ? item.material_unit_sale_price : null,
              material_values_overridden: Object.values(item.overridden_fields).find(value => value === true),
              material_group: item.material_group,
              overridden_material_fields: item.overridden_material_fields || null,
              plugin_metadata: item.plugin_metadata

            }
          })
          if (newItems.length > 0) {
            await deleteAllBomItemsAndInsert({ bomId: this.selectedBomId, bomVersionId: this.bomVersionId, bomItems: newItems })
          } else {
            await deleteAllBomItems(this.selectedBomId, this.bomVersionId)
          }
        }
        await updateStdBomVersions(this.bomVersionId, this.standardBomForm, this.stdBomTempId, this.stdBomVersionId)
        if (this.bomName !== this.tempBomName) await updateBomName(this.bomId, this.bomName, false)
        if (this.selectedDate !== this.selectedDateTemp) await updateEffectedDate(this.bomId, this.selectedDate, false)
        success('BOM updated Successfully!')
        loader.hide()
        this.cancelEdit()
      } catch (error) {
        loader.hide()
        const errorMessage = error?.message || error?.toString?.() || ''
        if (errorMessage.includes('Uniqueness')) {
          alert('BOM Name already exists')
        }
      }
    },
    openAssociateBomModal (item, index) {
      if (this.isObsoleteMaterial(item)) return
      this.associateBom.show = true
      this.associateBom.item = item
      this.associateBom.product_code = item.product_code
      this.associateBom.associated_bom_id = item.associated_bom_id
      this.associateBom.associated_bom_name = item.associated_bom_name
      this.associateBom.associated_bom_version = item.associated_bom_version
      this.associateBom.associated_bom_version_id =
        item.associated_bom_version_id
      this.associateBom.index = index
    },
    closeAssociateBomModal (bom) {
      this.associateBom.show = false
      this.associateBom.item = null
      this.associateBom.associated_bom_id = null
      this.associateBom.associated_bom_name = null
      this.associateBom.associated_bom_version = null
      this.associateBom.associated_bom_version_id = null
      this.associateBom.index = null
    },
    selectAssociateBom (bom) {
      if (bom?.id === this.selectedBomId) {
        warning('You cannot associate same BOM')
        return
      }
      this.bom_items[this.associateBom.index].associated_bom_id =
        bom?.id || null
      this.bom_items[this.associateBom.index].associated_bom_name =
        bom?.name || null
      this.bom_items[this.associateBom.index].associated_bom_version =
        bom?.version || null
      this.bom_items[this.associateBom.index].associated_bom_version_id =
        bom?.versionId || null
      this.bom_items[this.associateBom.index].material_unit_cost =
        bom?.total_cost || 0
      this.bom_items[this.associateBom.index].material_unit_sale_price =
        bom?.sale_price || 0
    },
    addToBom (item) {
      this.bom_items.push({
        material_id: item.id,
        material_name: item.material_name,
        custom_material_id: item.custom_material_id,
        quantity: item.quantity || 1,
        total_price: 0,
        unit_size: item.unit_size || 1,
        material_description: item.material_description,
        material_group: item.material_group,
        product_code: item.product_code,
        associated_bom_id: null,
        associated_bom_name: null,
        associated_bom_version: null,
        associated_bom_version_id: null,
        material_unit_cost: item.unit_cost,
        material_unit_sale_price: item.unit_sale_price,
        type: item.type,
        material_status: item.status,
        formId: item.core_form ? item.core_form.id : null,
        overridden_fields: {
          unit_cost: !!item.material_unit_cost,
          sale_price: !!item.material_unit_sale_price,
          material_group: !!item.material_group,
          resource_group: !!item.resource_group
        }
      })
    },

    updateUnitSize (index) {
      this.bom_items.splice(index + 1, 0, {
        ...this.bom_items[index]
      })
    },
    removeBomItem (item, index) {
      this.bom_items.splice(index, 1)
    },
    selectPage (page) {
      this.pageNumber = page
      this.fetchMaterialMasterData()
    },
    handleResize () {
      this.windowHeight = window.innerHeight
      this.scheduleMaterialTableMeasure({ fetchOnChange: true })
    },
    fetchMaterialMasterData () {
      const requestId = ++this.materialMasterRequestId
      const perPage = this.perPage
      this.materialMasterLoading = true
      const filter = {
        jump: (this.pageNumber - 1) * perPage,
        perPage,
        searchKeyword: this.searchKeyWord ? `%${this.searchKeyWord}%` : undefined
      }
      if (this.getTags.length > 0) {
        filter.tagId = this.getTags[this.getTags.length - 1]?.id
      }
      GetMaterialMasterForBom({ filter }).then((res) => {
        if (requestId !== this.materialMasterRequestId) return
        this.materialMasterData = res.core_material_master
        this.totalCount = res.core_material_master_aggregate.aggregate.count
        const lastPage = Math.max(1, Math.ceil(this.totalCount / perPage))
        if (this.pageNumber > lastPage) {
          this.pageNumber = lastPage
          this.fetchMaterialMasterData()
        }
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        if (requestId !== this.materialMasterRequestId) return
        this.materialMasterLoading = false
        this.$nextTick(() => {
          window.requestAnimationFrame(() => {
            this.settleMaterialTableOverflow()
          })
        })
      })
    },
    cancelEdit () {
      this.$router.push(`/bom/product/${this.$route.params.productCode}/bom/${this.selectedBomId}`)
    },
    updateProductCode () {
      this.productCode = this.$route.params.productCode
      GetProductCode(this.productCode).then((res) => {
        this.productName = res.product_code_by_pk.product_code
      })
    },
    ...mapMutations('tag', ['addNewTag', 'updateTags']),
    openRemarkModal (index) {
      if (this.isObsoleteMaterial(this.bom_items[index])) return
      this.addRemarkModalObject.selectedIndex = index
      this.addRemarkModalObject.remarks = this.bom_items[index]?.remarks || ''
      this.addRemarkModalObject.isOpen = true
    },
    saveRemarks () {
      this.bom_items[this.addRemarkModalObject.selectedIndex].remarks = this.addRemarkModalObject.remarks
      this.addRemarkModalObject.isOpen = false
    },
    validateUnitSize (index) {
      if (this.bom_items[index].unit_size <= 0) {
        alert('Unit size smaller than 0 is restricted.')
        this.bom_items[index].unit_size = 1
      }
    },
    validateQuantity (index) {
      if (this.bom_items[index].quantity <= 0) {
        alert('Quantity should be a positive number')
        this.bom_items[index].quantity = 1
      }
    },
    keyPress (e) {
      if (e instanceof KeyboardEvent && e.code === 'Escape') {
        this.cancelEdit()
      }
    },
    disableReplaceSelection (e) {
      this.replaceRowIndex = -1
    },
    async handleReplaceClick (item) {
      if (!this.replaceMode) return

      if (this.replaceRowIndex === -1) {
        alert('please select a material in bom to replace')
        return
      }

      await this.replaceBomMaterial(this.replaceRowIndex, item)
    },
    async replaceBomMaterial (index, newMaterial) {
      if (this.isSelfProductMaterial(newMaterial)) {
        alert('Cyclic dependency: a product cannot contain itself.')
        return
      }
      const oldItem = { ...this.bom_items[index] }
      // material duplicate check before  replacement start
      let duplicateMaterial = null
      for (const item of this.bom_items) {
        if (item.material_id === newMaterial.id && item.unit_size === oldItem.unit_size) {
          duplicateMaterial = true
          break
        }
      }
      if (duplicateMaterial) {
        alert(`${newMaterial.material_name} with unit size ${oldItem.unit_size} has alredy included in bom`)
      } else {
        const loader = new Loader()
        loader.show()
        let overRiddenMatFields = {}
        if (newMaterial?.core_form?.id) {
          const formData = await GetFormDataByFormId(newMaterial.core_form.id, false)
          overRiddenMatFields = formDataRetriver(formData.core_forms_by_pk)
        }
        this.bom_items[index].material_id = newMaterial.id
        this.bom_items[index].product_code = newMaterial.product_code
        this.bom_items[index].custom_material_id = newMaterial.custom_material_id
        this.bom_items[index].material_description = newMaterial.material_description
        this.bom_items[index].associated_bom_id = null
        this.bom_items[index].associated_bom_name = null
        this.bom_items[index].associated_bom_version = null
        this.bom_items[index].associated_bom_version_id = null
        this.bom_items[index].overridden_material_fields = overRiddenMatFields
        this.bom_items[index].material_status = newMaterial.status
        this.replaceRowIndex = -1
        loader.hide()
      }
      // material duplicate check before  replacement end
    },
    enableReplaceMode () {
      this.$refs.addOrReplace.style.left = '50%'
      this.replaceMode = true
      this.replaceRowIndex = -1
    },
    enabaleAddMode () {
      this.$refs.addOrReplace.style.left = '0%'
      this.replaceMode = false
      this.replaceRowIndex = -1
    },
    startResize (e) {
      resizeHelper.onMouseDown(e, this)
    }
  },
  mounted () {
    MaterialGroup().then(res => {
      res.custom_list_values.map((item) => {
        this.customList.push({
          name: item.name,
          id: item.id,
          type: 1
        })
      })
    })
    ResourceGroup('Resource Group').then((res) => {
      res.custom_list_values.map((item) => {
        this.customList.push({
          name: item.name,
          id: item.id,
          type: 2
        })
      })
    })
    this.updateOnSearch = debounce(() => {
      this.pageNumber = 1
      this.fetchMaterialMasterData()
    }, 500)
    window.addEventListener('resize', this.handleResize)
    this.$nextTick(() => {
      this.setupMaterialTableResizeObserver()
      this.scheduleMaterialTableMeasure({ fetch: true, resetPage: true })
    })
    this.updateProductCode()
    GetBomDetailById(this.selectedBomId).then((res) => {
      const bomDetail = res.core_bom_by_pk
      this.bomName = this.tempBomName = bomDetail?.name
      this.erpBomId = bomDetail?.erp_bom_id ?? ''
      this.bomId = bomDetail.id
      this.bomVersionId = bomDetail.bom_versions?.[0]?.id
      this.selectedDate = this.selectedDateTemp = bomDetail.effective_date
      Promise.all([GetAllBomItemsByBomVersionId(this.bomVersionId), GetAllBomVersionListByBomId(this.bomId)]).then(([res, versionRes]) => {
        this.bomVersions = versionRes.bom_versions
        this.selectedBomVersion = versionRes.bom_versions[0]?.id
        this.standardBomForm = versionRes.bom_versions[0]?.custom_fields?.values || null
        this.stdBomTempId = versionRes.bom_versions[0]?.custom_fields?.template_id || null
        this.stdBomVersionId = versionRes.bom_versions[0]?.custom_fields?.template_version_id || null
        const bomItems = res.bom_items.map((item) => {
          // if overrided value is not there pick the cost from assoc bom version or the material
          const unitCost = item.material_unit_cost ?? (item.associated_product_code_bom ? item.associated_bom_version?.total_cost : item.core_material.unit_cost)
          const salePrice = item.material_unit_sale_price ?? (item.associated_product_code_bom ? item.associated_bom_version?.sale_price : item.core_material.unit_sale_price)
          return {
            material_name: item.core_material.material_name,
            material_id: item.material_id,
            custom_material_id: item.core_material.custom_material_id,
            quantity: item.quantity,
            total_price: item.total_price,
            unit_size: +item.unit_size,
            remarks: item.remarks,
            material_unit_cost: unitCost,
            material_unit_sale_price: salePrice,
            material_group: item.material_group,
            material_description: item.core_material.material_description,
            product_code: item.core_material.product_code,
            associated_bom_id:
              item?.associated_bom_version?.core_bom?.id || null,
            associated_bom_name:
              item?.associated_bom_version?.core_bom?.name || null,
            associated_bom_version:
              item?.associated_bom_version?.version_no || null,
            associated_bom_version_id: item?.associated_bom_version?.id || null,
            type: item.core_material.type,
            material_status: item.core_material.status,
            overridden_material_fields: item.overridden_material_fields || null,
            formId: item.core_material.core_form ? item.core_material.core_form.id : null,
            overridden_fields: {
              unit_cost: !!item.material_unit_cost,
              sale_price: !!item.material_unit_sale_price,
              material_group: !!item.material_group,
              resource_group: !!item.resource_group
            },
            plugin_metadata: item.plugin_metadata
          }
        }) || []
        this.bom_items = JSON.parse(JSON.stringify(bomItems))
        this.currentBomItems = JSON.parse(JSON.stringify(bomItems))
        this.previousUnitSize = JSON.parse(JSON.stringify(this.bom_items))
      })
    })
    const resizer = this.$refs.resizer
    const left = this.$refs.left

    let isResizing = false
    let startX = 0
    let startWidth = 0

    resizer.addEventListener('mousedown', (e) => {
      isResizing = true
      startX = e.clientX
      startWidth = left.offsetWidth
      document.body.style.cursor = 'col-resize'
    })

    document.addEventListener('mousemove', (e) => {
      if (!isResizing) return

      const deltaX = e.clientX - startX
      left.style.width = `${startWidth + deltaX}px`
    })

    document.addEventListener('mouseup', () => {
      isResizing = false
      document.body.style.cursor = 'default'
    })
  },
  created () {
    document.body.addEventListener('keydown', this.keyPress)
  },
  beforeDestroy () {
    document.body.removeEventListener('keydown', this.keyPress)
    if (this.boundMove) document.removeEventListener('mousemove', this.boundMove)
    if (this.boundUp) document.removeEventListener('mouseup', this.boundUp)
    window.removeEventListener('resize', this.handleResize)
    if (this.materialTableResizeObserver) this.materialTableResizeObserver.disconnect()
    if (this.materialTableMeasureFrame) window.cancelAnimationFrame(this.materialTableMeasureFrame)
  }
}
</script>

<style lang="scss" scoped >
.custom-list-select {
  max-width: 100%;
  min-width: 100%;
  // margin: 0 0 0 10px;
  margin-right: auto;
  font-size: var(--text-s);
  background-color: var(--brand-light-color);
  line-height: 1;
  border: 1px solid var(--brand-color);
  border-radius: 4px;
  padding: 2px 1px;
  max-width: 124px;
}
.create-bom {
  height: 100%;
  min-height: 0;
  display: flex;
  overflow: hidden;
  .material {
    width: calc(100% - 500px);
    height: calc(100vh - 115px);
    &-bar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: var(--brand-color);
      padding: 4px 10px;
      margin-bottom: 10px;
      &--title {
        font-size: var(--text-xl);
        font-weight: 500;
      }
      input {
        background-color: white;
      }
    }
    &-table {
       overflow-x: auto;
      overflow-y: hidden;
      th,
    td {
      max-width: 80px; /* Set your desired max width for each column */
        overflow: hidden; /* Prevents content from overflowing */
        text-overflow: ellipsis; /* Adds ellipsis (...) for overflowing text */
        white-space: nowrap;
    }
    }
  }
  .addBomForm {
    height: auto;
    overflow-y: visible;
  }
  .bom-detail {
    background-color: var(--bg-color);
    // height: 60rem;
    width: 500px;
    height: 100%;
    min-height: 0;
    overflow-y: auto;
    padding: 10px;
    &-bar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: var(--brand-color);
      margin: -10px -10px 10px -10px;
      padding: 4px 10px;
      &--title {
        max-width: 100%;
        font-size: var(--text-xl);
        font-weight: 500;
        &-update{
      width: fit-content;
      text-wrap: nowrap
        }
      }
    }
    &-item {
      margin-top: 12px;
      max-height: 300px;
      overflow-y: auto;
      &--no-material {
        font-size: var(--text-base);
        font-weight: 500;
        text-align: center;
        border: var(--border);
        padding: 10px;
        color: var(--brand-color-1);
      }
    }
    .add-bom {
      opacity: 0.4;
      cursor: not-allowed;
      &.active {
        opacity: 1;
        cursor: pointer;
      }
    }
    .associated-bom {
      max-width: 80px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      &:hover {
        cursor: pointer;
        text-decoration: underline;
        color: var(--blue-color);
      }
    }
  }
  .pagination-footer{
width:100%;
display: flex;
justify-content: space-between;
  &-total{
    margin-top: 16px;
    display: flex;
  background: #ffc56761;
  padding: 0.5rem 0.5rem 0.5rem;
  border: 1px solid var(--brand-color);
  border-radius: 0.2em;
  width: fit-content;
  padding-inline: 10px;
  }
}
  .remarks {
  min-width: 50rem;
  min-height: 6rem;
  max-height: 70vh;
  max-width: 70rem;
}
}
.resized-box{
width: 100px !important;
}
.bom-item-row-disabled td {
  pointer-events: none;
  opacity: 0.5;
}
.bom-item-row-disabled td.action-cell {
  pointer-events: auto;
  opacity: 1;
}
.bom-action-footer {
  padding-bottom: 10px;
}
.selectedMaterial{
  background-color: #aca59b;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px
}
.materialReplaceMode:hover {
  background-color: #aca59b;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px
}
.material-row-cyclic td {
  opacity: 0.5;
  cursor: not-allowed;
}
.addorreplace{
  &-btnbox{
    position: relative;
    cursor: pointer;
    display: flex;
    background-color: var(--bg-color);
    border: 1px solid var(--brand-color);
    border-radius: 5px;

  }
  &-addbtn{
    background: transparent;
    padding: 2px 6px;
    z-index: 2;
    width: 60.17px;
    width: 60.17px;
    text-align: center;
    user-select: none;
  }
  &-replacebtn{
  background: transparent;
    padding: 2px 6px;
    z-index: 2;
    width: 60.17px;
    width: 60.17px;
    text-align: center;
    user-select: none;
  }
  &-selectedbg{
    position: absolute;
    background-color: var(--brand-color);
    border-radius: 5px;
    left: 0;
    top: 0;
    z-index: 1;
    right: 0;
    width: 50%;
    height: 100%;
    transition: 0.5s;
    padding-inline: 5;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 1px 10px;
    border: .2px solid rgb(176 168 168 / 10%);
  }
}
.drawer {
  overflow-y: auto;
  // height: 60rem;
}
</style>
